import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Hook that automatically updates the HTML dir and lang attributes
 * when the language changes for proper RTL/LTR support
 */
export const useLanguageDirection = () => {
  const { language, isRTL } = useLanguage();

  useEffect(() => {
    const updateDocumentDirection = () => {
      // Update the HTML element's dir and lang attributes
      document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
      document.documentElement.setAttribute('lang', language);

      // Also update the body class for additional styling control
      document.body.classList.remove('rtl', 'ltr');
      document.body.classList.add(isRTL ? 'rtl' : 'ltr');
    };

    // Set initial direction
    updateDocumentDirection();
  }, [language, isRTL]);

  return {
    isRTL,
    language,
  };
};
